/* eslint-disable max-len */
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import {
  GET_ALL_START,
  GET_ALL_SUCCESS,
  GET_ALL_ERROR,
  GET_SINGLE_START,
  GET_SINGLE_SUCCESS,
  GET_SINGLE_ERROR,
  UPLOAD_IMAGE_START,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_ERROR,
  ADD_START,
  ADD_SUCCESS,
  ADD_ERROR,
  DELETE_START,
  DELETE_SUCCESS,
  DELETE_ERROR,
  UPDATE_START,
  UPDATE_SUCCESS,
  EXPORT_START,
  EXPORT_SUCCESS,
  EXPORT_ERROR,
  UPDATE_ERROR,
  GET_HNL_PLANT_CODE_START,
  GET_HNL_PLANT_CODE_ERROR,
  GET_HNL_PLANT_CODE_SUCCESS,
  GET_HNL_PRODUCT_START,
  GET_HNL_PRODUCT_ERROR,
  GET_HNL_PRODUCT_SUCCESS,
} from './types';
import HttpService from '../../../services/Http';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import configUrl from '../../../config/config';
import StoreService from '../../../services/Store';

const getBackendErrorMessage = (error) => (typeof error?.response?.data === 'string' ? error.response.data : null)
  || error?.response?.data?.message
  || error?.response?.data?.error
  || error?.response?.data?.errors?.[0]?.message
  || error?.response?.data?.errors?.[0]
  || ApiErrorHandler.selectMessage(error);

export const getProducts = (page = 1, limit = 10) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_START });

    const res = await HttpService.get(
      `/product/plant-view-products/all?page=${page}&limit=${limit}`,
      { status: 'waiting' },
    );

    dispatch({
      type: GET_ALL_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const getProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_START });

    const res = await HttpService.get(
      `/product/plant-view-product-details/${id}`,
    );

    dispatch({
      type: GET_SINGLE_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: GET_SINGLE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const uploadImages = (data) => async (dispatch) => {
  try {
    dispatch({ type: UPLOAD_IMAGE_START });

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const res = await HttpService.post('/admin/upload-images', data, config);

    dispatch({
      type: UPLOAD_IMAGE_SUCCESS,
      payload: res.data,
    });
    toast.success('Images uploaded successfully');
  } catch (error) {
    dispatch({
      type: UPLOAD_IMAGE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const addProduct = (data) => async (dispatch) => {
  try {
    dispatch({ type: ADD_START });

    const res = await HttpService.post('/admin/create-product', data);

    dispatch({
      type: ADD_SUCCESS,
      payload: res.data,
    });
    toast.success('Product added successfully');
  } catch (error) {
    dispatch({
      type: ADD_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const getAdminProducts = (page = 1, limit = 12) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_START });

    const res = await HttpService.get(
      `/product/admin-view-products/all?page=${page}&limit=${limit}`,
      { status: 'waiting' },
    );

    dispatch({
      type: GET_ALL_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const getAdminProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_START });

    const res = await HttpService.get(
      `/product/admin-view-product-details/${id}`,
    );

    dispatch({
      type: GET_SINGLE_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: GET_SINGLE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const upadateProduct = (id, data) => async (dispatch) => {
  try {
    dispatch({ type: ADD_START });

    const res = await HttpService.patch(`/admin/edit-product/${id}`, data);

    dispatch({
      type: ADD_SUCCESS,
      payload: res.data,
    });
    toast.success('Product updated successfully');
  } catch (error) {
    dispatch({
      type: ADD_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_START });

    const res = await HttpService.delete(`/product/admin-delete-product/${id}`);

    dispatch({
      type: DELETE_SUCCESS,
      payload: res.data,
    });
    toast.success('Product deleted successfully');
  } catch (error) {
    dispatch({
      type: DELETE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const getAllProductsList = (values) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_START });
    const baseUrl = '/hflhnl/get-hfl-indents';
    const params = new URLSearchParams();
    if (values?.page) params.append('page', values?.page);
    if (values?.limit) params.append('limit', values?.limit);
    if (values?.prodName) params.append('prodName', values?.prodName);
    if (values?.plantIcStatus) params.append('plantIcStatus', values?.plantIcStatus);
    const string = `${baseUrl}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const res = await HttpService.get(`${string}`);

    dispatch({
      type: GET_ALL_SUCCESS,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const getAllRegionalHeadIndentsApprovals = (values) => async (
  dispatch,
) => {
  try {
    dispatch({ type: GET_ALL_START });
    const baseUrl = '/hflhnl/hfl-indents';
    const params = new URLSearchParams();
    if (values?.page) params.append('page', values?.page);
    if (values?.limit) params.append('limit', values?.limit);
    if (values?.prodName) params.append('prodName', values?.prodName);
    if (values?.rHStatus) params.append('rHStatus', values?.rHStatus);
    if (values?.hnlStatus) params.append('hnlStatus', values?.hnlStatus);
    if (values?.status) params.append('status', values?.status);
    if (values?.startDate) params.append('startDate', values?.startDate);
    if (values?.endDate) params.append('endDate', values?.endDate);
    if (values?.plantCode) {
      const trimmedPlantCode = values.plantCode.substring(0, 4); // Extract first 4 digits
      params.append('plantCode', trimmedPlantCode);
    }
    if (values?.materialCode) {
      const trimmedMaterialCode = values.materialCode.substring(0, 6); // Extract first 6 digits
      params.append('plantCode', trimmedMaterialCode);
    }
    if (values?.feedType) params.append('feedType', values?.feedType);
    const string = `${baseUrl}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const res = await HttpService.get(`${string}`);

    dispatch({
      type: GET_ALL_SUCCESS,
      payload: res?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
  }
};

export const updatePlantSideHnlRequests = (data, callBack) => async (
  dispatch,
) => {
  try {
    dispatch({ type: UPDATE_START });
    const response = await HttpService.put('/hflhnl/update-indent', data);
    dispatch({
      type: UPDATE_SUCCESS,
      payload: response?.data,
    });
    if (callBack) {
      callBack(response);
    }
  } catch (error) {
    dispatch({
      type: UPDATE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
  }
};

export const updateRegionalHeadHnlRequests = (data, callBack) => async (
  dispatch,
) => {
  try {
    dispatch({ type: UPDATE_START });
    const response = await HttpService.put('/hflhnl/rh-update-indent', data);
    dispatch({
      type: UPDATE_SUCCESS,
      payload: response?.data,
    });
    if (callBack) {
      callBack(response);
    }
  } catch (error) {
    dispatch({
      type: UPDATE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
  }
};

export const updateHnlIndentRequests = (data, callBack) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_START });
    const response = await HttpService.put('/hflhnl/hnl-update-indent', data);
    dispatch({
      type: UPDATE_SUCCESS,
      payload: response?.data,
    });
    if (callBack) {
      callBack(response);
    }
  } catch (error) {
    dispatch({
      type: UPDATE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
  }
};

export const exporRegionalHeadHnlIndentingApproval = (values) => async (
  dispatch,
) => {
  try {
    dispatch({ type: EXPORT_START });
    const baseUrl = '/hflhnl/export-indents';
    const params = new URLSearchParams();
    if (values?.status) {
      params.append('status', values?.status);
    }
    if (values?.plantCode) {
      params.append('plantCode', values?.plantCode);
    }
    if (values?.materialCode) {
      params.append('materialCode', values?.materialCode);
    }
    if (values?.feedType) {
      params.append('feedType', values?.feedType);
    }
    if (values?.startDate) params.append('startDate', values?.startDate);
    if (values?.endDate) params.append('endDate', values?.endDate);
    const res = await axios({
      url: `${configUrl.apiUrl}${baseUrl}?${params.toString()}`,
      method: 'GET',
      data: { status: 'finished' },
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With',
        Accept: 'application/json',
        session: StoreService.getToken(),
      },
    });
    const url = window.URL.createObjectURL(
      new Blob([res.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `${localStorage.getItem('userName')}-HNL-INDENTS-${moment().format(
        'YYYY-MM-DD',
      )}.xlsx`,
    );
    document.body.appendChild(link);
    link.click();
    dispatch({
      type: EXPORT_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: EXPORT_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};

export const getPlantAndMaterialCodes = (values) => async (dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_START });

    const baseUrl = '/hflhnl/plantCode-materialCodes';
    const params = new URLSearchParams();
    if (values?.rHStatus) params.append('rHStatus', values?.rHStatus);
    if (values?.hnlStatus) params.append('hnlStatus', values?.hnlStatus);
    const string = `${baseUrl}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const res = await HttpService.get(`${string}`);

    dispatch({
      type: GET_SINGLE_SUCCESS,
      payload: res.data,
    });

    return res.data;
  } catch (error) {
    dispatch({
      type: GET_SINGLE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
    throw error;
  }
};

export const getFilterDropDownData = (regionName) => async (dispatch) => {
  try {
    dispatch({ type: GET_SINGLE_START });

    const baseUrl = regionName
      ? `/hflhnl/manual-HFL-admin-filter-dropdown?regionName=${encodeURIComponent(regionName)}`
      : '/hflhnl/manual-HFL-admin-filter-dropdown';
    const res = await HttpService.get(baseUrl);
    const payload = res.data?.data ?? res.data;

    dispatch({
      type: GET_SINGLE_SUCCESS,
      payload,
    });

    return payload;
  } catch (error) {
    dispatch({
      type: GET_SINGLE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
    throw error;
  }
};

export const getSummaryReport = (values) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_START });
    const baseUrl = '/hflhnl/manual-material-quantities';
    const params = new URLSearchParams();
    if (values?.regionName) params.append('regionName', values?.regionName);
    if (values?.plantName) params.append('plantName', values?.plantName);
    if (values?.productCategory) params.append('productCategory', values?.productCategory);
    if (values?.productName) params.append('productName', values?.productName);
    if (values?.startDate) params.append('startDate', values?.startDate);
    if (values?.endDate) params.append('endDate', values?.endDate);
    const string = `${baseUrl}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const res = await HttpService.get(`${string}`);
    const payload = res.data?.data ?? res.data;
    dispatch({
      type: GET_ALL_SUCCESS,
      payload,
    });
    return payload;
  } catch (error) {
    dispatch({
      type: GET_ALL_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
    throw error;
  }
};

export const getRegionWiseData = (values) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_START });
    const baseUrl = '/hflhnl/manual-get-regionWise-data';
    const params = new URLSearchParams();
    if (values?.regionName) params.append('regionName', values?.regionName);
    if (values?.plantName) params.append('plantName', values?.plantName);
    if (values?.productCategory) params.append('productCategory', values?.productCategory);
    if (values?.productName) params.append('productName', values?.productName);
    if (values?.plant) params.append('plant', values?.plant);
    if (values?.startDate) params.append('startDate', values?.startDate);
    if (values?.endDate) params.append('endDate', values?.endDate);
    const string = `${baseUrl}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const res = await HttpService.get(`${string}`);
    const payload = res.data?.data ?? res.data;
    dispatch({
      type: GET_ALL_SUCCESS,
      payload,
    });
    return payload;
  } catch (error) {
    dispatch({
      type: GET_ALL_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
    throw error;
  }
};

export const getSummaryReportCsv = (values) => async (dispatch) => {
  try {
    dispatch({ type: EXPORT_START });

    const baseUrl = '/hflhnl/manual-material-quantities';
    const params = new URLSearchParams();
    if (values?.regionName) params.append('regionName', values?.regionName);
    if (values?.plantName) params.append('plantName', values?.plantName);
    if (values?.productCategory) params.append('productCategory', values?.productCategory);
    if (values?.productName) params.append('productName', values?.productName);
    if (values?.startDate) params.append('startDate', values?.startDate);
    if (values?.endDate) params.append('endDate', values?.endDate);
    params.append('flag', 'export');

    const res = await axios({
      url: `${configUrl.apiUrl}${baseUrl}?${params.toString()}`,
      method: 'GET',
      data: { status: 'finished' },
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With',
        Accept: 'application/json',
        session: StoreService.getToken(),
      },
    });
    const url = window.URL.createObjectURL(
      new Blob([res.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `${localStorage.getItem('userName')}-SUMMARY-REPORT-${moment().format(
        'YYYY-MM-DD',
      )}.xlsx`,
    );
    document.body.appendChild(link);
    link.click();
    dispatch({
      type: EXPORT_SUCCESS,
    }); // Return data for fetch case
  } catch (error) {
    dispatch({
      type: EXPORT_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
    throw error;
  }
};

const appendIndentSummaryReportParams = (params, values = {}) => {
  if (values?.reportType) params.append('reportType', values.reportType);
  if (values?.regionName) params.append('regionName', values.regionName);
  if (values?.plantName) params.append('plantName', values.plantName);
  if (values?.productCategory) params.append('productCategory', values.productCategory);
  if (values?.productName) params.append('productName', values.productName);
  if (values?.datePreset) params.append('datePreset', values.datePreset);
  if (values?.startDate) params.append('startDate', values.startDate);
  if (values?.endDate) params.append('endDate', values.endDate);
  if (values?.detail) params.append('detail', values.detail);
};

export const getIndentSummaryReport = (values) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_START });
    const baseUrl = '/hflhnl/manual-indent-summary-report';
    const params = new URLSearchParams();
    appendIndentSummaryReportParams(params, values);
    const string = `${baseUrl}${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const res = await HttpService.get(`${string}`);
    const payload = res.data?.data ?? res.data;
    dispatch({
      type: GET_ALL_SUCCESS,
      payload,
    });
    return payload;
  } catch (error) {
    dispatch({
      type: GET_ALL_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
    throw error;
  }
};

export const getIndentSummaryReportCsv = (values) => async (dispatch) => {
  try {
    dispatch({ type: EXPORT_START });
    const baseUrl = '/hflhnl/manual-indent-summary-report';
    const params = new URLSearchParams();
    appendIndentSummaryReportParams(params, values);
    params.append('flag', 'export');

    const res = await axios({
      url: `${configUrl.apiUrl}${baseUrl}?${params.toString()}`,
      method: 'GET',
      data: { status: 'finished' },
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With',
        Accept: 'application/json',
        session: StoreService.getToken(),
      },
    });
    const url = window.URL.createObjectURL(
      new Blob([res.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute(
      'download',
      `${localStorage.getItem('userName')}-INDENT-SUMMARY-${moment().format(
        'YYYY-MM-DD',
      )}.xlsx`,
    );
    document.body.appendChild(link);
    link.click();
    dispatch({
      type: EXPORT_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: EXPORT_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
    throw error;
  }
};

export const getAllHnlDropdownData = (type, filters = {}) => async (
  dispatch,
) => {
  try {
    dispatch({ type: GET_HNL_PLANT_CODE_START });
    const params = new URLSearchParams({ type });
    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key])) {
        if (filters[key].length > 0) params.append(key, filters[key].join(','));
      } else if (filters[key]) params.append(key, filters[key]);
    });
    const response = await HttpService.get(
      `hflhnl/fetch-plantCodes?${params.toString()}`,
    );
    if (response?.status === 200) {
      const data = response?.data?.data;
      dispatch({ type: GET_HNL_PLANT_CODE_SUCCESS, payload: data });
      return data;
    }
  } catch (error) {
    dispatch({
      type: GET_HNL_PLANT_CODE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
  }
  return null;
};

export const getHnlPlantCodes = (type, dataKey) => async (dispatch) => {
  try {
    dispatch({ type: GET_HNL_PLANT_CODE_START });
    const response = await HttpService.get(
      `hflhnl/fetch-plantCodes?type=${type}`,
    );
    // console.log('getHnlPlantCodes', response);
    const data = response?.data.data[dataKey];
    if (response?.status === 200) {
      dispatch({
        type: GET_HNL_PLANT_CODE_SUCCESS,
        payload: data,
      });
      return data;
    }
  } catch (error) {
    dispatch({
      type: GET_HNL_PLANT_CODE_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
  }
  return null;
};

export const fetchManualIndent = (values) => async (dispatch) => {
  try {
    dispatch({ type: GET_HNL_PRODUCT_START });
    const params = new URLSearchParams({
      type: values?.type,
      page: values?.page,
      limit: values?.limit,
    });
    const appendFilterParam = (key) => {
      const value = values?.[key];
      if (Array.isArray(value)) {
        if (value.length > 0) params.append(key, value.join(','));
      } else if (value) {
        params.append(key, value);
      }
    };
    [
      'regionName',
      'plantCode',
      'productName',
      'requiredDate',
      'orderedDate',
      'plantName',
      'productCategory',
      'materialCode',
      'materialDescription',
      'sortby',
    ].forEach(appendFilterParam);
    const response = await HttpService.get(
      `hflhnl/fetch-manualIndents?${params.toString()}`,
    );
    if (response?.status === 200) {
      dispatch({
        type: GET_HNL_PRODUCT_SUCCESS,
        payload: response.data,
      });
    }
    return response.data.paginate;
  } catch (error) {
    dispatch({
      type: GET_HNL_PRODUCT_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    return null;
  }
};

export const saveManualIndent = (
  typeOrPayload,
  payloadOnly,
  callback,
) => async (dispatch) => {
  try {
    dispatch({ type: GET_HNL_PRODUCT_START });
    // Determine if `typeOrPayload` is the `type` or the actual `payload`
    const hasType = typeof typeOrPayload === 'string';
    const type = hasType ? typeOrPayload : null;
    const payload = hasType ? payloadOnly : typeOrPayload;
    // Make the API call based on the presence of `type`
    const endpoint = type
      ? `hflhnl/save-manualIndents?type=${type}`
      : 'hflhnl/save-manualIndents';
    const response = await HttpService.post(endpoint, payload);
    if (response?.status === 200) {
      if (callback) {
        callback(response);
      }
      dispatch({
        type: GET_HNL_PRODUCT_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    const message = getBackendErrorMessage(error);
    dispatch({
      type: GET_HNL_PRODUCT_ERROR,
      payload: message,
    });
    if (callback) {
      callback({
        success: false,
        status: ApiErrorHandler.errorCode(error),
        message,
      });
    }
    return { success: false, message };
  }
  return null;
};

export const updateManualIndent = (payload) => async (dispatch) => {
  try {
    dispatch({ type: GET_HNL_PRODUCT_START });
    const response = await HttpService.put(
      'hflhnl/update-manualIndents',
      payload,
    );
    if (response?.status === 200) {
      dispatch({
        type: GET_HNL_PRODUCT_SUCCESS,
        payload: response.data,
      });
    }
    return {
      success: response?.status === 200 && response?.data?.success !== false,
      data: response?.data,
      message: response?.data?.message,
    };
  } catch (error) {
    const message = error?.response?.data?.message || ApiErrorHandler.selectMessage(error);
    dispatch({
      type: GET_HNL_PRODUCT_ERROR,
      payload: message,
    });
    return { success: false, message };
  }
};

export const uploadManualIndentsExcel = (data, callback) => async (
  dispatch,
) => {
  try {
    dispatch({ type: GET_HNL_PRODUCT_START });
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    const response = await HttpService.post(
      '/hflhnl/upload-excel-manualIndents',
      data,
      config,
    );
    if (
      (response?.status === 200 || response?.status === 201)
      && response?.data?.success !== false
    ) {
      if (callback) {
        callback(response);
      }
      dispatch({
        type: GET_HNL_PRODUCT_SUCCESS,
        payload: response?.data,
      });
      toast.success('Excel uploaded successfully');
    } else {
      const errorData = response?.data || {};
      dispatch({
        type: GET_HNL_PRODUCT_ERROR,
        payload: errorData.message || 'Unknown error occurred during upload',
      });
      if (callback) {
        callback({
          success: false,
          status: errorData.status || 500,
          message: errorData.message,
        });
      }
    }
  } catch (error) {
    dispatch({
      type: GET_HNL_PRODUCT_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    if (callback) {
      callback({
        success: false,
        status: ApiErrorHandler.errorCode(error),
        message:
          error?.response?.data?.message
          || ApiErrorHandler.selectMessage(error),
      });
    }
  }
};

export const exportRegionalHeadManualIndent = ({
  type,
  flag,
  filters = {},
}) => async (dispatch) => {
  try {
    dispatch({ type: EXPORT_START });
    const baseUrl = '/hflhnl/fetch-manualIndents';
    const params = new URLSearchParams({ type, flag });
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (Array.isArray(value)) {
        if (value.length > 0) params.append(key, value.join(','));
      } else if (value) {
        params.append(key, value);
      }
    });
    const url = `${configUrl.apiUrl}${baseUrl}?${params.toString()}`;

    const res = await axios({
      url,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With',
        Accept: 'application/json',
        session: StoreService.getToken(),
      },
    });
    const downloadUrl = window.URL.createObjectURL(
      new Blob([res.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    );
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute(
      'download',
      `${localStorage.getItem('userName')}-HNL-INDENTS-${moment().format(
        'YYYY-MM-DD',
      )}.xlsx`,
    );
    document.body.appendChild(link);
    link.click();

    dispatch({
      type: EXPORT_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: EXPORT_ERROR,
      payload: ApiErrorHandler.selectMessage(error),
    });
    toast.error(ApiErrorHandler.selectMessage(error));
  }
};
